<template>
  <div id="app">
    <Navbar />
    <Hero />
    <OurStory />
<MenuSection @item-added="handleItemAdded" />
    <ExperienceGallery />
    <LocationSection />
<BookingForm ref="bookingForm" />
    <FooterSection />
  </div>
</template>

<script>
import Navbar from './components/Navbar.vue'
import Hero from './components/hero.vue'
import MenuSection from './components/MenuSection.vue'
import OurStory from './components/OurStory.vue'
import ExperienceGallery from './components/ExperienceGallery.vue'
import LocationSection from './components/LocationSection.vue'
import BookingForm from './components/BookingForm.vue'
import FooterSection from './components/FooterSection.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    Hero,
    MenuSection,
    OurStory,
    ExperienceGallery,
    LocationSection,
    BookingForm,
    FooterSection
  },
  methods: {
    handleItemAdded(itemName) {
      this.$refs.bookingForm.addItemToRequest(itemName);
    }
  }}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  

}

html {
  scroll-behavior: smooth;
}

body {
  font-family: 'Poppins', sans-serif;
  overflow-x: hidden;
  background-color: #FFF8DC;
}

#app {
  width: 100%;
  min-height: 100vh;
}
</style>